export default "__VITE_ASSET__Drin1M3p__"